// import React, { useState } from 'react';
// import { useParams } from 'react-router-dom';
// import CorporateOnboarding from '../components/child/CorporateOnboarding';
// import CorporateShareholding from '../components/child/CorporateShareholding';
// import CorporateBankAccount from '../components/child/CorporateBankAccount';
// import CorporateDocument from '../components/child/CorporateDocument';
// import CorporateInvestment from '../components/child/CorporateInvestment';

// const CorporateClientDetails = () => {
//     const { id } = useParams();
//     const [activeTab, setActiveTab] = useState("company");

//     return (
//         <div className="container mt-4">
//             {/* <h2>Client Details (ID: {id})</h2> */}

//             <ul className="nav nav-pills nav-fill">
//                 <li className="nav-item">
//                     <button 
//                         className={`nav-link ${activeTab === "company" ? "active" : ""}`} 
//                         onClick={() => setActiveTab("company")}
//                     >
//                         Company Info
//                     </button>
//                 </li>
//                 <li className="nav-item">
//                     <button 
//                         className={`nav-link ${activeTab === "shareholder" ? "active" : ""}`} 
//                         onClick={() => setActiveTab("shareholder")}
//                     >
//                         Shareholders
//                     </button>
//                 </li>
//                 <li className="nav-item">
//                     <button 
//                         className={`nav-link ${activeTab === "bank" ? "active" : ""}`} 
//                         onClick={() => setActiveTab("bank")}
//                     >
//                         Bank Details
//                     </button>
//                 </li>
//                 <li className="nav-item">
//                     <button 
//                         className={`nav-link ${activeTab === "documents" ? "active" : ""}`} 
//                         onClick={() => setActiveTab("documents")}
//                     >
//                         Documents
//                     </button>
//                 </li>

//                 <li className="nav-item">
//                     <button 
//                         className={`nav-link ${activeTab === "investment" ? "active" : ""}`} 
//                         onClick={() => setActiveTab("investment")}
//                     >
//                         NAV Investment
//                     </button>
//                 </li>
//             </ul>

//             <div className="mt-3">
//                 {activeTab === "company" && <CorporateOnboarding company_id={id} />} 
//                 {activeTab === "shareholder" && <CorporateShareholding company_id={id} />} 
//                 {activeTab === "bank" && <CorporateBankAccount company_id={id} />} 
//                 {activeTab === "documents" && <CorporateDocument company_id={id} />} 
//                 {activeTab === "investment" && <CorporateInvestment company_id={id} />} 
//             </div>
//         </div>
//     );
// };

// export default CorporateClientDetails;

import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import CorporateOnboarding from '../components/child/CorporateOnboarding';
import CorporateShareholding from '../components/child/CorporateShareholding';
import CorporateBankAccount from '../components/child/CorporateBankAccount';
import CorporateDocument from '../components/child/CorporateDocument';
import CorporateInvestment from '../components/child/CorporateInvestment';

const CorporateClientDetails = () => {
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState("company");

    return (
        <div className="container mt-4">
                        <ul className="nav nav-pills nav-fill d-flex flex-wrap">

                {[
                    { key: "company", label: "Company Info" },
                    { key: "shareholder", label: "Shareholders" },
                    { key: "bank", label: "Bank Details" },
                    { key: "documents", label: "Documents" },
                    { key: "investment", label: "NAV Investment" }
                ].map((tab) => (
                    <li className="nav-item mx-1" key={tab.key} style={{ flex: "1 1 auto" }}>

                        <button 
                            className={`nav-link ${activeTab === tab.key ? "active" : "bg-secondary text-white"}`} 
                            onClick={() => setActiveTab(tab.key)}
                            style={{ borderRadius: "5px" }} // Optional: For rounded corners
                        >
                            {tab.label}
                        </button>
                    </li>
                ))}
            </ul>

            <div className="mt-3">
                {activeTab === "company" && <CorporateOnboarding company_id={id} />}
                {activeTab === "shareholder" && <CorporateShareholding company_id={id} />}
                {activeTab === "bank" && <CorporateBankAccount company_id={id} />}
                {activeTab === "documents" && <CorporateDocument company_id={id} />}
                {activeTab === "investment" && <CorporateInvestment company_id={id} />}
            </div>
        </div>
    );
};

export default CorporateClientDetails;

